import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {

    id?: number | string;
    name: string;
    email: string;
    phone: any;
    userRoleId: number;
    seniorIds?: any;
    location?: any
    firstName?: string;
    lastName?: string;

};

export const addUser = ({ id, name,email,phone, userRoleId ,seniorIds, location, firstName, lastName}: requestDTO) => {
    if(id){
        return axios.post(`/superadmin/update-user`, {id, name,firstName, lastName, email,phone, userRoleId ,seniorIds, location});
    }else{

        return axios.post(`/superadmin/create-user`, {name,firstName, lastName, email,phone, userRoleId ,seniorIds, location});
    }
};

type UseAddUserOptions = {
  config?: MutationConfig<typeof addUser>;
};

export const useUserMutation = ({ config }: UseAddUserOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      // showNotification({
      //   type: 'success',
      //   title: 'User added successfully',
      // });
    },
    ...config,
    mutationFn: addUser,
  });
};
